import React, {Component} from 'react';
import { withStyles } from "@material-ui/core/styles";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import RecordPagination from '../../utils/RecordsPagination';

import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
    Chip
} from "@material-ui/core";
import Tooltip from '@material-ui/core/Tooltip';
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import {appHelpers} from "../../_helpers";
import {appConstants} from "../../_constants";

const CustomTableCell = withStyles(theme => ({
    head: {
        color: appConstants.REGIONAL_COLOR,
        fontSize: "14px",
        fontWeight: "lighter"
    },
    body: {
        fontSize: 14
    }
}))(TableCell);

const chipCommonStyle  = {
    borderRadius: '5px',
    color: '#fff'
};

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    input: {
        marginTop: "0 !important"
    },
    nb: {
        color: "red",
        fontSize: "12px"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: "67%"
    },
    root: {
        flexGrow: 1
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "100%"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    airlineSelect: {
        marginTop: "0px",
        width: '100%'
    },
    icon: {
        margin: "8px 0px 8px 0px",
        position: "relative",
        top: "7px",
        paddingLeft: "8px",
    },
    chipPrimary: {
        ...chipCommonStyle,
        background: appConstants.INFO_COLOR,
        '&:hover': {
            background: appConstants.INFO_COLOR,
        },
        '&:focus': {
            background: appConstants.INFO_COLOR,
        }
    },
    chipSecondary: {
        ...chipCommonStyle,
        background: appConstants.PRIMARY_COLOR,
        '&:hover': {
            background: appConstants.PRIMARY_COLOR,
        },
        '&:focus': {
            background: appConstants.PRIMARY_COLOR,
        }
    },
    chipDefault: {
        ...chipCommonStyle,
        background: appConstants.DANGER_COLOR,
        '&:hover': {
            background: appConstants.DANGER_COLOR,
        },
        '&:focus': {
            background: appConstants.DANGER_COLOR,
        }
    },
});


const Record = (props) => {
    const { data, handleApprovalModal, classes, pageIndex,} = props;

    return (
        <div>
            <div className={classes.tableResponsive}
                 style={{ overflowX: "auto" }}>
            <Table className={classes.table} aria-labelledby="tableTitle">
                <TableHead className={classes.negativeColor} color="primary">
                    <TableRow>
                        <CustomTableCell>S/No</CustomTableCell>
                        <CustomTableCell >Entity</CustomTableCell>
                        <CustomTableCell >Created By</CustomTableCell>
                        <CustomTableCell >Created <br /> Date </CustomTableCell>
                        <CustomTableCell >Approved By</CustomTableCell>
                        <CustomTableCell >Status</CustomTableCell>
                        <CustomTableCell >Action</CustomTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((record, key) => {
                        return (
                            <TableRow hover key={key}>
                                <TableCell >{pageIndex + key}</TableCell>
                                <TableCell >{appHelpers.interpretEntityTypeId(record.EntityTypeId)}</TableCell>
                                <TableCell >{record.CreatedBy}</TableCell>
                                <TableCell >{(record.CreatedDate) ? appHelpers.formatDate(record.CreatedDate, "MMM DD, YYYY, hh:mm a") : ""}</TableCell>
                                <TableCell >{record.ApprovedBy}</TableCell>
                                <TableCell >
                                        {record.StatusId === 0 &&
                                                <Chip
                                                    label={"Pending"}
                                                    clickable
                                                    className={classes.chipPrimary}
                                                />
                                        }
                                        {record.StatusId === 1 &&
                                        <Chip
                                            label={"Approved"}
                                            clickable
                                            className={classes.chipSecondary}
                                        />
                                        }
                                        {record.StatusId === 2 &&
                                        <Chip
                                            label={"Rejected"}
                                            clickable
                                            className={classes.chipDefault}
                                        />
                                        }
                                </TableCell>
                                <TableCell>
                                     <span style={{ cursor: "pointer" }} onClick={() => handleApprovalModal(record)}>
                                         <Tooltip title="View" placement="top">
                                                 <span className={classes.icon}><ViewIcon /></span>
                                             </Tooltip>
                                     </span>
                                </TableCell>
                            </TableRow>
                            )}
                            )}
                </TableBody>
            </Table>
        </div>
        </div>
    );
};

class recordTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const {classes, data, handleApprovalModal, fetchMakerCheckerRecord, totalCount, pageSize,
            currentPage
        } = this.props;
        const pageIndex = (pageSize * (currentPage - 1)) + 1;
        return (
            <div>
                <RecordPagination
                    fetchMore={fetchMakerCheckerRecord}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    target={<Record
                        pageIndex={pageIndex}
                        classes={classes}
                        data={data}
                        handleApprovalModal={handleApprovalModal}
                    />}
                />
            </div>
        )
    }

}
export default (withMobileDialog()(withStyles(styles)(recordTable)));


// WEBPACK FOOTER //
// ./src/Regional-Views/MakerChecker/record.js